import { Check, Copy, CreditCard } from "lucide-react";
import { useState } from "react";

function CopyButton({ text }: { text: string }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <button
      onClick={handleCopy}
      className="ml-2 text-amber-600 hover:text-amber-800 transition-colors"
      title="Copy"
    >
      {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
    </button>
  );
}

function Field({ label, value, copyValue }: { label: string; value: string; copyValue?: string }) {
  return (
    <div className="flex items-center justify-between gap-4">
      <span className="text-amber-700 text-xs shrink-0">{label}</span>
      <div className="flex items-center">
        <span className="font-mono text-xs font-medium text-gray-900 bg-white px-2 py-0.5 rounded border border-amber-200">
          {value}
        </span>
        {copyValue && <CopyButton text={copyValue} />}
      </div>
    </div>
  );
}

export function TestCardInfo() {
  if (!import.meta.env.DEV) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 w-72 bg-amber-50 border border-amber-300 rounded-lg shadow-lg p-3 space-y-2.5">
      <div className="flex items-center gap-1.5 text-amber-800">
        <CreditCard className="h-4 w-4" />
        <span className="text-xs font-semibold">Stripe Test Card</span>
      </div>
      <div className="space-y-1.5">
        <Field label="Number" value="4242 4242 4242 4242" copyValue="4242424242424242" />
        <Field label="CVC" value="Any 3 digits" />
        <Field label="Expiry" value="Any future date" />
      </div>
      <p className="text-[10px] text-amber-600">Only visible in local dev.</p>
    </div>
  );
}
